import { createSlice } from "@reduxjs/toolkit";
import { Pagination } from "../../../utils/api";

export type BookingSearch = {
  id: number;
  customer_reference: string;
  booking_reference: string;
  vehicle_number: string;
  trailer_number: string;
};

type InitialState = {
  data: BookingSearch[];
  meta: Pagination | null;
  isLoading: boolean;

  archivedData: BookingSearch[];
  archivedMeta: Pagination | null;
  archivedIsLoading: boolean;

  search: string;
};

const initialState: InitialState = {
  data: [],
  meta: null,
  isLoading: false,

  archivedData: [],
  archivedMeta: null,
  archivedIsLoading: false,

  search: "",
};

const bookingSearchSlice = createSlice({
  name: "bookingSearchSlice",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.isLoading = true;
      state.data = [];
      state.meta = null;
      state.search = action.payload;
    },
    setData: (state, action) => {
      const { data, meta } = action.payload.bookings;

      state.data = data;
      state.meta = meta;

      const { data: archivedData, meta: archivedMeta } =
        action.payload.archivedBookings;

      state.archivedData = archivedData;
      state.archivedMeta = archivedMeta;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default bookingSearchSlice;
